import React from 'react';
import { Button } from 'components/ui/button';
import { Modal } from 'react-bootstrap-5';

import { callListUrl, CALL_LISTS_SHOW } from '../../../helpers/prospect_api';

type Props = {
  callListId: number;
  handleClose: () => void;
}

export default function ImportModalComplete({
  callListId,
  handleClose,
}: Props) {
  return (
    <>
      <Modal.Header className="flex-row" closeButton>
        <Modal.Title as="h5">Upload Complete</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Your upload has been completed and processed.
          You can begin your outreach on those properties right away.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button label="Close" variant="ghost" onClick={handleClose} />
        <Button href={callListUrl(CALL_LISTS_SHOW, callListId)} label="View List" variant="secondary" />
      </Modal.Footer>
    </>
  );
}
